import React, { useState } from "react";
import { Pagination, Typography } from "antd";

const { Text } = Typography;

const PaginationComponent = ({
  setPage,
  totalPages,
  totalItems,
  itemsPerPage,
  currentPage: currentPageFromAPI,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const handleChange = (page) => {
    setCurrentPage(page);
    setPage(page - 1);
  };

  if (!totalPages) return null;

  return (
    <div
      style={{
        padding: "12px 24px",
        borderTop: "1px solid #f0f0f0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Text type="secondary" style={{ fontSize: 13 }}>
        Page {currentPage} of {totalPages + 1}
      </Text>
      <Pagination
        current={currentPage}
        total={(totalPages + 1) * (itemsPerPage || 50)}
        pageSize={itemsPerPage || 50}
        onChange={handleChange}
        showSizeChanger={false}
        showQuickJumper
        size="small"
      />
    </div>
  );
};

export default PaginationComponent;
